<template>
  <div>
    <div class="row mb-3">
      <div class="form-group col-md-4">
        <label>{{ $t("Central") }}:</label>
        <v-select
            :options="centerOptions"
            :reduce="(item) => item.id"
            label="name"
            v-model="filters.center_id"
            class="vselect"
            @input="handleCenterChange"
            :loading="loadingStates.centers"
        />
      </div>
      <div class="form-group col-md-4">
        <label>{{ $t("Unidade") }}:</label>
        <v-select
            :options="unitOptions"
            :reduce="(item) => item.id"
            label="name"
            v-model="filters.unit_id"
            class="vselect"
            :disabled="!filters.center_id"
            @input="handleUnitChange"
            :loading="loadingStates.units"
        />
      </div>
      <div class="form-group col-md-4">
        <label>{{ $t("Dispositivo") }}:</label>
        <v-select
            :options="deviceOptions"
            :reduce="(item) => item.id"
            label="name"
            v-model="filters.device_id"
            class="vselect"
            :loading="loadingStates.devices"
        />
      </div>
    </div>

    <div v-if="!filters.device_id" class="hik-camera-empty">
      <feather-icon icon="VideoIcon" size="32" />
      <p>{{ $t("Selecione um dispositivo para ver as câmeras da dashcam") }}</p>
    </div>

    <hik-camera-grid v-else :device-id="filters.device_id" />
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "HikCamera",

  components: {
    // async: mantém o hls.js (~1.5MB) fora do bundle carregado em toda página
    HikCameraGrid: () => import("./HikCameraGrid"),
  },

  data() {
    return {
      filters: {
        center_id: null,
        unit_id: null,
        device_id: null,
      },
      loadingStates: {
        centers: false,
        units: false,
        devices: false,
      },
      centers: [],
      units: [],
      devices: [],
    };
  },

  computed: {
    centerOptions() {
      return [{ id: null, name: "Todos" }, ...this.centers];
    },

    unitOptions() {
      return [{ id: null, name: "Todos" }, ...this.units];
    },

    deviceOptions() {
      return this.devices.map((device) => ({
        id: device.id,
        name: device.description || device.serial_number || `Dispositivo #${device.id}`,
      }));
    },
  },

  created() {
    this.loadCenters();
    this.loadDevices();
  },

  methods: {
    async loadCenters() {
      this.loadingStates.centers = true;
      try {
        const response = await axios.get(`${this.$store.state.api}centers/`);
        this.centers = Array.isArray(response.data) ? response.data : (response.data.data || []);
      } catch (error) {
        this.$error(error);
      } finally {
        this.loadingStates.centers = false;
      }
    },

    async loadUnits(centerId) {
      if (!centerId) {
        this.units = [];
        return;
      }
      this.loadingStates.units = true;
      try {
        const response = await axios.get(`${this.$store.state.api}centers/unit/${centerId}`);
        this.units = Array.isArray(response.data) ? response.data : (response.data.data || []);
      } catch (error) {
        this.$error(error);
      } finally {
        this.loadingStates.units = false;
      }
    },

    async loadDevices() {
      this.loadingStates.devices = true;
      try {
        const params = {};
        if (this.filters.center_id) params.center_id = this.filters.center_id;
        if (this.filters.unit_id) params.unit_id = this.filters.unit_id;

        const response = await axios.get(`${this.$store.state.api}devices/hikvision-selectable`, { params });
        this.devices = Array.isArray(response.data) ? response.data : [];
      } catch (error) {
        this.$error(error);
      } finally {
        this.loadingStates.devices = false;
      }
    },

    handleCenterChange() {
      this.filters.unit_id = null;
      this.filters.device_id = null;
      this.loadUnits(this.filters.center_id);
      this.loadDevices();
    },

    handleUnitChange() {
      this.filters.device_id = null;
      this.loadDevices();
    },
  },
};
</script>

<style scoped>
.hik-camera-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 4rem 1rem;
  color: #6e6b7b;
  text-align: center;
}
</style>
